import { logger } from 'utils/logger';

/** Add statuses as needed */
export enum PostMessageStatus {
  FORMS_ONBOARDING_COMPLETE = 'forms-onboarding-complete', // Prime Onboarding
  FORMS_EDIT_CONTACTS = 'forms-edit-contacts',
  FORMS_DOWNLOAD_DOCUMENT = 'forms-download-document',
  FORMS_CREATE_FILE = 'forms-create-file',
  FORMS_BULK_FILL = 'forms-bulk-fill',
  FORMS_BUYER_AGREEMENT_RENAME = 'forms-buyer-agreement-rename',
  FORMS_PREPARE_SIGNATURE = 'forms-prepare-signature',
}

export interface PostMessagePayload {
  status?: PostMessageStatus;
  // Add metadata as needed, currently mobile doesn't need it, but this is the format
  // we want to follow for the widget.
  metadata?: {
    fileId?: number;
    formsEnvelopeId?: number;
    formsDocumentIds?: number[];
  };
}

export type PostMessageArgs = {
  msg: PostMessagePayload;
  target?: string;
};

/**
 * A hook that allows posting a message to any integrators following our proposed mobile message format.
 * Payload can be extended to fit integrator needs
 */
export function usePostMessage(): (args: PostMessageArgs) => void {
  return (args: PostMessageArgs) => {
    const { msg, target = '' } = args;
    if (window.environmentKey !== 'prod') logger.log('Post Message: ', msg);
    window.parent.postMessage(JSON.stringify(msg), target === '' ? '*' : target);
  };
}
